/**
 * Fitnesspilot
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SportFromJSON, SportToJSON } from "./Sport";
/**
 * Check if a given object implements the SportsSummaryResponse interface.
 */
export function instanceOfSportsSummaryResponse(value) {
    let isInstance = true;
    isInstance = isInstance && "sports" in value;
    return isInstance;
}
export function SportsSummaryResponseFromJSON(json) {
    return SportsSummaryResponseFromJSONTyped(json, false);
}
export function SportsSummaryResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        sports: json.sports.map(SportFromJSON),
    };
}
export function SportsSummaryResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        sports: value.sports.map(SportToJSON),
    };
}
